// extracted by mini-css-extract-plugin
export default {"ButtonArchive":"s_ButtonArchive__OVbQG","button":"s_button__TNMXv"};